import React, { useState } from 'react';
import { Button, Menu, MenuItem, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import CheckIcon from '@material-ui/icons/Check';
import { VIEW_OPTIONS, VIEWS } from '../helpers/statusConfig';

const useStyles = makeStyles(() => ({
  btn: {
    textTransform: 'none',
    borderRadius: 24,
    backgroundColor: '#FFFFFF',
    color: '#000000',
    border: '1px solid #000000',
    padding: '6px 18px',
    fontWeight: 500,
    minWidth: 240,
    justifyContent: 'space-between',
    boxShadow: 'none',
    '&:hover': { backgroundColor: '#F4F6FB' },
  },
  item: {
    fontSize: '0.85rem',
    minWidth: 240,
  },
}));

const ViewPicker = ({ value, onChange, role }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const options =
    role === 'CMO' ? VIEW_OPTIONS.filter((o) => o.key !== VIEWS.POST_DELIVERY) : VIEW_OPTIONS;
  const current = options.find((o) => o.key === value) || options[0];

  return (
    <>
      <Button
        className={classes.btn}
        endIcon={<ArrowDropDownIcon />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        {current.label}
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        getContentAnchorEl={null}
      >
        {options.map((o) => (
          <MenuItem
            key={o.key}
            selected={o.key === value}
            className={classes.item}
            onClick={() => { onChange(o.key); setAnchorEl(null); }}
          >
            {o.key === value
              ? <CheckIcon style={{ fontSize: 16, marginRight: 8, color: '#173072' }} />
              : <span style={{ width: 24 }} />}
            <Typography style={{fontWeight: 500,}}>{o.label}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ViewPicker;
